import styled from 'styled-components';


export const ContentWrapper = styled.div`
display:flex;
flex-direction:row;
align-items:center;
`